import { combineReducers } from 'redux'
import reducer from './Reducer'

const rootReducer = combineReducers({
    survey: reducer,
});

export default rootReducer